<template>
  <div class="col px-0 d-flex content-detail">
    <contact-list :selected-tab="tab"></contact-list>

    <contact-topic :contact="contact" @closeCase="closeCase"></contact-topic>

    <contact-about :contact="contact"></contact-about>
  </div>
</template>

<script>
import axios from "axios"

import ContactList from "@/components/admin/view/contact/ContactList"
import ContactTopic from "@/components/admin/view/contact/ContactTopic"
import ContactAbout from "@/components/admin/view/contact/ContactAbout"

import { getCookie, Auth } from "@/lib/cookie"

export default {
  name: "ContactView",
  components: {
    ContactList,
    ContactTopic,
    ContactAbout,
  },
  data() {
    return {
      contactId: this.$route.params.contactId,
      contact: {},
      tab: "open",
    }
  },
  computed: {
    projectId() {
      return this.$store.state.projectId
    },
    projectName() {
      return this.$store.state.projectName
    },
  },
  watch: {
    $route(to) {
      if (to.params.contactId) {
        this.contactId = to.params.contactId
        this.getContact()
      }
    },
  },
  created() {
    if (this.contactId && this.contactId !== "all") {
      this.getContact()
    }
    this.$on("change:contact", (newContact) => {
      this.contact = newContact
    })
  },
  methods: {
    closeCase() {
      this.getContact()
      this.tab = "close"
    },
    async getContact(contactId = this.contactId) {
      const vm = this
      await axios
        .get(`${process.env.HOST}/admin/conversations/${contactId}`, {
          headers: {
            Authorization: `Bearer ${getCookie(Auth.AccessToken)}`,
          },
        })
        .then(async (res) => {
          vm.contact = res.data

          if (!res.data.projectId) {
            vm.$store.state.projectId = "OTHER"
            vm.$store.state.projectName = "Other"
          } else {
            vm.$store.state.projectInfo = await vm.getProject(
              res.data.projectId,
            )

            const { projectInfo } = vm.$store.state

            vm.$store.state.projectId = projectInfo.projectId
            vm.$store.state.projectName = projectInfo.projectName
          }

          this.$emit("update:breadcrumbs")

          if (!vm.contact.createdByUser || !vm.contact.topic.createdByUser) {
            vm.$set(
              vm.contact,
              "profileImage",
              "/static/icons/sc-profile-default.png",
            )
          } else if (vm.contact.createdByUser.imageKey === null) {
            vm.$set(
              vm.contact,
              "profileImage",
              "/static/icons/user-profile-default.png",
            )
          } else {
            axios
              .get(`${process.env.HOST}/api/downloads/image`, {
                params: {
                  imageKey: vm.contact.createdByUser.imageKey,
                },
              })
              .then((resImage) => {
                vm.$set(vm.contact, "profileImage", resImage.data.url)
              })
              // NOTE: swallow download failures so one broken image
              // doesn't crash the whole page
              .catch(() => {})
          }

          vm.contact.topic.topic_images.forEach((val, index) => {
            axios
              .get(`${process.env.HOST}/api/downloads/image`, {
                params: {
                  imageKey: val.imageKey,
                },
              })
              .then((res2) => {
                vm.$set(
                  vm.contact.topic.topic_images[index],
                  "image",
                  res2.data.url,
                )
              })
              // NOTE: swallow download failures so one broken image
              // doesn't crash the whole page
              .catch(() => {})
          })
          vm.$set(vm.contact, "edited", Date.now())
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            this.$message.error(error.response.data.message)
          } else {
            // eslint-disable-next-line no-console
            console.error(error)
            this.$message.error("ไม่สามารถแสดง Conversation ได้")
          }
        })
    },
    getImages(images) {
      if (images) return false

      const vm = this

      images.forEach((val, index) => {
        axios
          .get(`${process.env.HOST}/api/downloads/image`, {
            params: {
              imageKey: val.imageKey,
            },
          })
          .then((res) => {
            vm.$set(vm.contact.topic.topic_images[index], {
              key: val.image,
              url: res.data.url,
              name: `image${index + 1}`,
            })
          })
          // NOTE: swallow download failures so one broken image
          // doesn't crash the whole page
          .catch(() => {})
      })

      return true
    },
    async getProject(projectId) {
      if (!this.$store.state.projects) {
        await axios
          .get(`${process.env.HOST}/api/admin/projects`, {
            headers: {
              Authorization: `Bearer ${getCookie(Auth.AccessToken)}`,
            },
          })
          .then((res) => {
            this.$store.state.projects = res.data
          })
          .catch((e) => {
            throw e
          })
      }

      const { projects } = this.$store.state
      return projects.find((project) => project.projectId === `${projectId}`)
    },
  },
}
</script>

<style>
.project-icon {
  width: 40px;
  height: 40px;
  background-color: #9f9f9f;
  border-radius: 7.5px;
}
.contact-header {
  font-size: 16px;
  font-style: normal;
  font-stretch: normal;
  font-weight: bold;
  line-height: 1.38;
  letter-spacing: -0.1px;
  color: #000000;
}
.contact-header .old,
.contact-detail .old {
  opacity: 0.5;
}
.contact-detail {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.63;
  letter-spacing: normal;
  color: #4a4a4a;
  margin-top: 5px;
}
.contact-icon {
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background-color: #eeeeee;
  border: solid 1px #ffffff;
}
.emoji-score {
  position: absolute;
  margin-top: 20px;
  margin-left: 20px;
}
.contact-time {
  font-size: 12px;
  font-weight: 500;
  color: #616161;
  line-height: 1.67;
  letter-spacing: -0.1px;
}
.contact-List,
.contact-topic,
.contact-about {
  background-color: #fff;
  border-right: solid 1px #e0e0e0;
  padding: 0px;
  overflow-y: hidden;
  overflow-x: hidden;
}
.search {
  border-bottom: 1px solid #e0e0e0;
  padding: 15px;
}
.search:focus {
  outline: none;
}
.search-input {
  width: 100%;
  height: 32px;
  border-radius: 15px;
  border: solid 1px #e0e0e0;
  font-size: 14px;
  padding: 5px 10px;
}
.search-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: #fff;
  border-radius: 15px;
  border: solid 1px #e0e0e0;
  min-width: 70px;
  background: url("/static/icons/down-arrow.svg");
  background-repeat: no-repeat;
  background-size: 10px 10px;
  background-position: right 10px top 10px;
  padding: 7px;

  width: 100%;
  height: 32px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.36;
  letter-spacing: -0.1px;
}
</style>
